<template>
  <el-dialog
    :visible="isDialogVisible"
    append-to-body
    class="news-popup-dialog"
    @close="closeDialog"
  >
    <!-- Close Icon -->
    <div class="custom-close-btn" @click="closeDialog">
      <i class="el-icon-close"></i>
    </div>

    <div v-if="newsData" class="news-popup-content">
      <el-image :src="newsData.image_url" fit="cover" class="news-image-popup" />
      <div class="main-section">
        <h2>{{ newsData.title }}</h2>
        <p>{{ newsData.summary }}</p>

        <!-- Meta section for source and date -->
        <div class="news-meta">
          <p class="news-source">{{ newsData.source }}</p>
          <p class="news-date">{{ formatDate(newsData.pub_date) }}</p>
        </div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import moment from "moment";

export default {
  props: {
    isVisible: Boolean,
    newsData: Object,
  },
  computed: {
    isDialogVisible: {
      get() {
        return this.isVisible;
      },
      set(value) {
        this.$emit("update:isVisible", value); // Emit event to update parent value
      },
    },
  },
  methods: {
    formatDate(date) {
      return moment(date).format("MMM DD, YYYY hh:mm A");
    },
    closeDialog() {
      this.$emit("update:isVisible", false);
    },
  },
};
</script>

<style lang="scss">
.news-popup-dialog {
  .el-dialog {
    max-width: 600px;
    width: 98%;
    border-radius: 10px;
    box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.2);

    .el-dialog__header {
      display: none;
    }

    .el-dialog__body {
      padding: 0px;
    }
  }

  /* Close button styling */
  .custom-close-btn {
    position: absolute;
    top: 10px;
    right: 15px;
    font-size: 20px;
    cursor: pointer;
    color: black;
    z-index: 2;

    &:hover {
      color: #000;
    }
  }
}
</style>

<style lang="scss" scoped>
/* Scoped styles for news popup */
.news-popup-content {
  display: flex;
  flex-direction: column;

  .news-image-popup {
    width: 100%;
    height: 250px;
    object-fit: cover;
    border-radius: 8px;
  }

  .main-section {
    padding: 20px;
  }

  h2 {
    font-size: 15px;
    font-weight: 700;
    margin: 15px 0;
    color: #000000;
  }

  p {
    font-size: 12px;
    font-weight: 400;
    color: #000000;
    margin-bottom: 10px;
  }

  /* Flexbox for source and date */
  .news-meta {
    display: flex;
    justify-content: space-between;
    width: 100%;
    font-size: 10px;
    color: #818181;
    font-weight: 500;

    .news-source {
      text-align: left;
    }

    .news-date {
      text-align: right;
    }
  }
}
</style>